// extracted by mini-css-extract-plugin
export default {"fallbackImage":"Dishes_fallbackImage__7n0DP"};